import { Component, OnInit, ViewChild, OnDestroy, Input } from '@angular/core';
import { State, Store } from '@ngrx/store';
import { AppState, selectOperacionState, selectDetalleFacturaState } from 'app/store/app.states';
import { AsignarOperacion } from 'app/store/actions/operacion.actions';
import { BaseService } from 'app/services/base.service';
import { CoalService } from 'app/services/coal.service';
import { Router } from '@angular/router';
import { ConfirmDialogComponent } from 'app/utilerias/confirm-dialog/confirm-dialog.component';
import { RelacionadosDialogComponent } from 'app/utilerias/relacionados-dialog/relacionados-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTable } from '@angular/material/table';
import { MostrarExcepcion, MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { Observable } from 'rxjs';
import { ConfirmDialogOkComponent } from 'app/utilerias/confirm-dialog-ok/confirm-dialog-ok.component';
import { ConfirmDialogOpcionComponent } from 'app/utilerias/confirm-dialog-opcion/confirm-dialog-opcion.component';
import { map, startWith } from 'rxjs/operators';
import { filters } from '../../../../mock-api/apps/mailbox/data';
import { messages } from '../../../../mock-api/apps/chat/data';
import { All } from '../../../../store/actions/operacion.actions';
import { DatePipe } from '@angular/common';
import { DocsRelacionadosComponent } from '../docsRelacionados/docsRelacionados.component';

interface Food {
    value: string;
    viewValue: string;
}
const datosTabla1: any[] = [

];
@Component({
    selector: 'app-pagos',
    templateUrl: './pagos.component.html',
    styleUrls: ['./pagos.component.scss']
})

export class PagosComponent implements OnInit, OnDestroy {
    /**IMPUTUS OUTPUTS */
    @Input() ltsMoneda: any[];
    /**
     * Id de MXN dentro del catálogo de monedas. El id NO es estable entre ambientes
     * (depende del orden en que se pobló c_Moneda), así que debe resolverse por clave.
     */
    private get idMonedaMXN(): any {
        return this.ltsMoneda?.find(option => option?.attributes?.clave === 'MXN')?.id ?? null;
    }
    @Input() ltsMetodoPago: any[];
    @Input() indexPagos: number;
    @Input() ltsFormaPago: any[];
    @Input() banderaActualizarFactura: boolean;
    @Input() dataUpdateComplemento: any;
    @Input() ltsObjetoImpuesto: any[];
    @Input() pago: { id: string, child?: PagosComponent };
    /**IMPUTUS OUTPUTS */

    getStateOperacion: Observable<any>;
    subscribeOperacion: any;
    idOperacion: number;
    Operacion: any;
    getStateDetalleFactura: Observable<any>;
    complementoPagoForm: FormGroup;

    countDocsRel: { id: string,index: number, child?: DocsRelacionadosComponent }[] = [];
    lsNombre: string = '';
    idDocRelacionados: string;
    dataUpdateDocsRelacionados: any = [];
    // lstObjetoImp: any [];
    opcionesFiltradas: Observable<any[]>;

    constructor(
        private readonly store: Store<AppState>,
        private fb: FormBuilder,
        private baseService: BaseService,
        private coalService: CoalService,
        private router: Router,
        public dialog: MatDialog,
        private _formBuilder: FormBuilder,
        private _snackBar: MatSnackBar,
        private datePipe: DatePipe
    ) {


    }


    private _filtrarMonedas(value: any): any[] {
        const filterValue = value?.toLowerCase();

        return this.ltsMoneda.filter(moneda =>
        (moneda.attributes.clave.toLowerCase().includes(filterValue) ||
            moneda.attributes.descripcion.toLowerCase().includes(filterValue))
        );
    }



    ngOnDestroy(): void {
        this.baseService.postDetalleFactura(null);
    }

    ngOnInit(): void {
        this.pago.child = this;
        this.lsNombre = 'Pago ' + this.indexPagos;
        // this.GetObjetoImpuesto();
        if (!this.banderaActualizarFactura) {
            this.countDocsRel.push({ id: 'docRel' + this.indexPagos, index: this.indexPagos });
        };

        let jsonSend = {
            "pago": {
                "data": {},
                "documentosRelacionados": [[
                    { id: 'docRel' + (this.countDocsRel.length === 0 ? 1 : this.countDocsRel.length) },
                    { "data": {} },
                    {
                        "impuestos": []
                    }
                ]
                ]
            }
        };

        localStorage.setItem(this.lsNombre, JSON.stringify(jsonSend));
        // Llamar a addMetodoPago
        this.addMetodoPago(jsonSend,'Add');

         // Obtener el arreglo existente de documentos
       let allDocs = JSON.parse(localStorage.getItem('allDocs')) || [];
        
       // Verificar si el documento ya existe
       const existingDocIndex = allDocs.findIndex(doc => doc.lsnombre === this.lsNombre);
       
       if (existingDocIndex !== -1 )  {
           // Actualizar el documento existente
           allDocs[existingDocIndex].data = jsonSend;
       } else {
           // Añadir el nuevo documento al arreglo
           allDocs.push({ lsnombre: this.lsNombre, data: jsonSend });
       }
       
       // Guardar el arreglo actualizado en el localStorage
       localStorage.setItem('allDocs', JSON.stringify(allDocs));

        this.getStateOperacion = this.store.select(selectOperacionState);
        // this.subscribeOperacion = this.getStateOperacion.subscribe((operacion) => {
        //     this.idOperacion = operacion.idOperacion;
        //     this.Operacion = operacion;
        // });
        this.getStateDetalleFactura = this.store.select(selectDetalleFacturaState);

        this.complementoPagoForm = this.fb.group({
            fechaPago: new FormControl(this.getFechaActual(), Validators.required),
            horaPago: new FormControl(this.getHoraActual(), Validators.required),
            formaPago: new FormControl(null, Validators.required),
            montoPago: [0, [Validators.pattern('^[0-9]+(\\.[0-9]{1,2})?$'), Validators.required]],
            monedaComplemento: new FormControl(1, Validators.required),
            tipoCambioComplemento: new FormControl(1, Validators.required),
            numeroOperacion: new FormControl('0'),
            rfcCuentaOrdenante: new FormControl(''),
            cuentaOrdenante: new FormControl(''),
            nombreBanco: new FormControl(''),
            rfcCuentaBeneficiario: new FormControl(''),
            cuentabeneficiario: new FormControl('')
        });



        this.opcionesFiltradas = this.complementoPagoForm.get('monedaComplemento').valueChanges.pipe(
            startWith(''),
            map(state => (state ? this._filtrarMonedas(state) : this.ltsMoneda)),
        );


        this.complementoPagoForm.valueChanges.subscribe(res => {
            let lsJson = JSON.parse(localStorage.getItem(this.lsNombre));
            lsJson['pago'].data = res;
            localStorage.removeItem(this.lsNombre);
            localStorage.setItem(this.lsNombre, JSON.stringify(lsJson));

            // Llamar a addMetodoPago
            this.addMetodoPago(lsJson,'remove');
        });

        let avanza =  (this.dataUpdateComplemento?.id ?? false) ? true : false;

        if (this.banderaActualizarFactura && avanza) {
            const formaPag = this.ltsFormaPago.find(
                (item) => item.id === this.dataUpdateComplemento?.attributes?.cat_forma_pago?.data?.id
            )
            console.log("legaron estos pagos", this.dataUpdateComplemento)
            this.complementoPagoForm.controls.fechaPago.setValue(this.dataUpdateComplemento.attributes.fechaPago);
            this.complementoPagoForm.controls.horaPago.setValue(this.dataUpdateComplemento.attributes.horaPago);
            this.complementoPagoForm.controls.formaPago.setValue(formaPag);
            this.complementoPagoForm.controls.montoPago.setValue(this.dataUpdateComplemento.attributes.montoPago);
            this.complementoPagoForm.controls.monedaComplemento.setValue(this.dataUpdateComplemento.attributes.cat_moneda.data ? this.dataUpdateComplemento.attributes.cat_moneda.data.id : null);
            if (this.dataUpdateComplemento.attributes.cat_moneda.data.id == this.idMonedaMXN) {
                this.complementoPagoForm.controls.tipoCambioComplemento.disable();
                this.complementoPagoForm.controls.tipoCambioComplemento.setValue(1);
            } else {
                this.complementoPagoForm.controls.tipoCambioComplemento.setValue(this.dataUpdateComplemento.attributes.tipoCambio);
                this.complementoPagoForm.controls.tipoCambioComplemento.enable();
            }
            this.complementoPagoForm.controls.numeroOperacion.setValue(this.dataUpdateComplemento.attributes.numeroOperacion);
            this.complementoPagoForm.controls.rfcCuentaOrdenante.setValue(this.dataUpdateComplemento.attributes.rfcCuentaOrdenante);
            this.complementoPagoForm.controls.cuentaOrdenante.setValue(this.dataUpdateComplemento.attributes.cuentaOrdenante);
            this.complementoPagoForm.controls.nombreBanco.setValue(this.dataUpdateComplemento.attributes.nombreBanco);
            this.complementoPagoForm.controls.rfcCuentaBeneficiario.setValue(this.dataUpdateComplemento.attributes.rfcCuentaBeneficiario);
            this.complementoPagoForm.controls.cuentabeneficiario.setValue(this.dataUpdateComplemento.attributes.cuentaBeneficiario);
            if (this.dataUpdateComplemento.attributes.fac_com_pago_documentos.data.length > 0) {
                console.log("si hay documentos", this.dataUpdateComplemento.attributes.fac_com_pago_documentos.data)
                this.getDocsRelacionados(this.dataUpdateComplemento.attributes.fac_com_pago_documentos.data);
            }

        }else{
            if(this.banderaActualizarFactura){
                this.addDocumentos();
            }
        }
    };

    displayFn = (moneda: any): string => {
        const monedaEncontrada = this.ltsMoneda.find((f: any) => f.id === moneda);
        if (monedaEncontrada) {
            return `${monedaEncontrada.attributes.clave} - ${monedaEncontrada.attributes.descripcion}`;
        } else {
            return '';
        }
    }


    getFechaActual() {
        const fechaActual = new Date();
        return fechaActual
    }

    getHoraActual(): string {
        const horaActual = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        return horaActual;
    }
    getDocsRelacionados = idComplemento => {
        const data = {
            idComplemento: idComplemento
        };
        console.log("idComplemento", idComplemento)
        // this.coalService.postService(`catalogo/selDocsRelacionadosComplemento`, data).subscribe((res: any) => {
        // this.coalService.getService(`fac-complemento-pagos/${idComplemento}?populate=*`).subscribe((res: any) => {
        this.countDocsRel = [];
        this.removeDocumentos();
        for (let data of idComplemento) {
            console.log("res data documento", data)
            setTimeout(() => {
                this.dataUpdateDocsRelacionados = data;
                this.addDocumentos();
            }, 10);
        };
        // }, (error: any) => {
        //     console.log('Error al traer los documentos relacionado')
        // });
    };
    // GetObjetoImpuesto() {
    //     // !this.banderaActualizarFactura ? this.store.dispatch(MostrarSpinner()):null;
    //     this.coalService.getService(`cat-objeto-impuestos`,).subscribe((res: any) => {
    //         if (res.err) {
    //           // this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
    //           console.log("erro *************** 1")
    //         } else {
    //           this.lstObjetoImp = res.data
    //           console.log('tipo impuesto', res.data)
    //           this.store.dispatch(OcultarSpinner());
    //         }
    //       }, (error: any) => {
    //           console.log("erro *************** 3", error)
    //           this.store.dispatch(OcultarSpinner());
    //           // this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
    //           // this.spinner = false;
    //       });
    //   }
    changeFechaPago = value => {
        this.complementoPagoForm.controls.fechaPago.setValue(value)
    };

    formatoFecha = date => {
        function pad(s) {
            return (s < 10) ? '0' + s : s;
        }
        const d = new Date(date)
        return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('-')
    };

    changeMoneda = value => {
        this.complementoPagoForm.controls.tipoCambioComplemento.reset();
        if (value == 1) {
            this.complementoPagoForm.controls.tipoCambioComplemento.disable();
            this.complementoPagoForm.controls.tipoCambioComplemento.setValue(1);
        } else {
            this.complementoPagoForm.controls.tipoCambioComplemento.enable();
        }
    };

    addDocumentos = () => {
        let lsJson = JSON.parse(localStorage.getItem(this.lsNombre));
        this.countDocsRel.push({ id: 'docRel' + this.countDocsRel.length, index: this.indexPagos });
        lsJson['pago'].documentosRelacionados.push([{ id: 'docRel' + this.countDocsRel.length }, { data: {} }, { impuestos: [] }]);
        localStorage.removeItem(this.lsNombre);
        localStorage.setItem(this.lsNombre, JSON.stringify(lsJson));
        
       // Llamar a addMetodoPago
        this.addMetodoPago(lsJson,'Add');
    };

    removeDocumentos = () => {
        let lsJson = JSON.parse(localStorage.getItem(this.lsNombre));
        this.countDocsRel.splice(-1);
        lsJson['pago'].documentosRelacionados.splice(-1);
        localStorage.removeItem(this.lsNombre);
        localStorage.setItem(this.lsNombre, JSON.stringify(lsJson));

        // Llamar a addMetodoPago
        this.addMetodoPago(lsJson,'remove');
        

    };

    inhabilitar(objeto) {
        let metodoPago = objeto?.value?.attributes;
        metodoPago?.rfcDelEmisorDeLaCuentaOrdenante ? this.complementoPagoForm.controls['rfcCuentaOrdenante'].enable() : this.complementoPagoForm.controls['rfcCuentaOrdenante'].disable()
        metodoPago?.cuentaOrdenante ? this.complementoPagoForm.controls['cuentaOrdenante'].enable() : this.complementoPagoForm.controls['cuentaOrdenante'].disable();
        metodoPago?.bancarizado ? this.complementoPagoForm.controls['nombreBanco'].enable() : this.complementoPagoForm.controls['nombreBanco'].disable();
        metodoPago?.rfcDelEmisorCuentaDeBeneficiario ? this.complementoPagoForm.controls['rfcCuentaBeneficiario'].enable() : this.complementoPagoForm.controls['rfcCuentaBeneficiario'].disable();
        metodoPago?.cuentaDeBenenficiario ? this.complementoPagoForm.controls['cuentabeneficiario'].enable() : this.complementoPagoForm.controls['cuentabeneficiario'].disable();

    }

    validatePago() {
        console.log("validando pago");
        this.complementoPagoForm.markAllAsTouched();
        this.complementoPagoForm.updateValueAndValidity();
        let docsValid = true;
        this.countDocsRel.forEach(d => {
            const res = d.child?.validateDocumento() ?? true;
            docsValid = docsValid && res;
        });
        return this.complementoPagoForm.valid && docsValid;
    }

    addMetodoPago = (JSON_,tipo) => {
        
        if(tipo === 'remove'){
            // Obtener el arreglo existente de documentos
            let allDocs = JSON.parse(localStorage.getItem('allDocs')) || [];
            // Filtrar el documento que se va a eliminar
            allDocs = allDocs.filter(doc => doc.lsnombre !== this.lsNombre);
            // Guardar el arreglo actualizado en el localStorage
            localStorage.setItem('allDocs', JSON.stringify(allDocs));
        }


        if(tipo === 'Add'){
            // Obtener el arreglo existente de documentos
            let allDocs = JSON.parse(localStorage.getItem('allDocs')) || [];
            // Verificar si el documento ya existe
            const existingDocIndex = allDocs.findIndex(doc => doc.lsnombre === this.lsNombre);
            if (existingDocIndex !== -1) {
                // Actualizar el documento existente
                allDocs[existingDocIndex].data = JSON_;
            } else {
                // Añadir el nuevo documento al arreglo
                allDocs.push({ lsnombre: this.lsNombre, data: JSON_ });
            }
            // Guardar el arreglo actualizado en el localStorage
            localStorage.setItem('allDocs', JSON.stringify(allDocs));
        }

    };
};
